"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styled = require("./styled");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const CellInput = _ref => {
  let {
    onChange,
    value
  } = _ref;
  const textareaRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (!textareaRef.current) return;
    textareaRef.current.style.height = 'auto';
    if (!value) return;
    textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px';
  }, [value]);
  const handleChange = e => {
    if (!onChange) return;
    onChange(e.target.value);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.CellInput, {
    ref: textareaRef,
    value: value,
    onChange: handleChange
  });
};
CellInput.propTypes = {
  value: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func
};
var _default = exports.default = CellInput;